import { FormSetting } from '@/form-settings/form-setting';
import { ControlType } from '@components/dynamic-form/control-type';

export class CommissionsFormSettings extends FormSetting {
  protected static classToCall: string;

  public static setClassToCall(classes) {
    this.classToCall = classes;

    return this;
  }

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'anno',
            label: 'Anno',
            controlType: ControlType.textInput,
            class: 'lg:w-4/12 w-full',
            order: 1,
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'tipoVenditore',
            label: 'Tipo Venditore',
            controlType: 'dropdown',
            class: 'lg:w-4/12 w-full',
            order: 1,
            required: true,
            options: this.data['sellerTypes'] ?? [],
          },
          {
            classToUse: this.classToCall,
            key: 'percentualeProvvigione',
            label: '% Provvigione',
            controlType: 'number',
            class: 'lg:w-4/12 w-full',
            order: 1,
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'enabled',
            controlType: 'slide-toggle',
            label: 'Abilitato',
            default: true,
            order: 1,
            class: 'lg:w-3/12 w-full',
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'id',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
          {
            classToUse: this.classToCall,
            key: 'creator',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
        ],
        order: 1,
      },
    ];
  }
}
